<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på adress</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import AddressRepository from '@services/repositories/AddressRepository';

export default {
    name: 'AddressFilter',
    components: {
        VueSelect,
    },
    data() {
        return {
            options: [],
        };
    },
    created() {
        const client = new AddressRepository();
        client.getAll().then((res) => {
            this.options = res.map((item) => ({
                id: item.id,
                label: item.name + ', ' + item.address + ', ' + item.zip_code + ', ' + item.city,
                item,
            }));
        });
    },
};
</script>
